"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDocumentAuditComparisonExtractedCertificationDto = instanceOfDocumentAuditComparisonExtractedCertificationDto;
exports.DocumentAuditComparisonExtractedCertificationDtoFromJSON = DocumentAuditComparisonExtractedCertificationDtoFromJSON;
exports.DocumentAuditComparisonExtractedCertificationDtoFromJSONTyped = DocumentAuditComparisonExtractedCertificationDtoFromJSONTyped;
exports.DocumentAuditComparisonExtractedCertificationDtoToJSON = DocumentAuditComparisonExtractedCertificationDtoToJSON;
exports.DocumentAuditComparisonExtractedCertificationDtoToJSONTyped = DocumentAuditComparisonExtractedCertificationDtoToJSONTyped;
/**
 * Check if a given object implements the DocumentAuditComparisonExtractedCertificationDto interface.
 */
function instanceOfDocumentAuditComparisonExtractedCertificationDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('expiration' in value) || value['expiration'] === undefined)
        return false;
    return true;
}
function DocumentAuditComparisonExtractedCertificationDtoFromJSON(json) {
    return DocumentAuditComparisonExtractedCertificationDtoFromJSONTyped(json, false);
}
function DocumentAuditComparisonExtractedCertificationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'expiration': json['expiration'],
    };
}
function DocumentAuditComparisonExtractedCertificationDtoToJSON(json) {
    return DocumentAuditComparisonExtractedCertificationDtoToJSONTyped(json, false);
}
function DocumentAuditComparisonExtractedCertificationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'expiration': value['expiration'],
    };
}
//# sourceMappingURL=DocumentAuditComparisonExtractedCertificationDto.js.map